import React from 'react'
import createIcon from '../createSvgIcon'

const path = (
    /* eslint-disable max-len */
    <g>
        <path
            fill='#46b549'
            d='M46.8 10.41c0 2.79-1.08 5.41-3.05 7.36l-10.4 10.42a10.387 10.387 0 0 1-7.37 3.04c-2.26 0-4.45-.72-6.23-2.05l2.32-2.32c2.81 1.76 6.67 1.39 9.01-.94L41.49 15.5a7.172 7.172 0 0 0 2.1-5.09c0-3.97-3.23-7.2-7.2-7.2-1.93 0-3.74.75-5.09 2.11l-5.11 5.1c-1.24-.42-2.49-.68-3.74-.8l6.57-6.57C30.98 1.08 33.6 0 36.39 0 42.13 0 46.8 4.67 46.8 10.41zM5.32 31.3a7.128 7.128 0 0 0-2.11 5.1c0 3.97 3.23 7.19 7.2 7.19 1.92 0 3.73-.74 5.09-2.09l5.03-5.05c1.22.42 2.47.7 3.72.83l-6.48 6.47a10.315 10.315 0 0 1-7.36 3.05C4.67 46.8 0 42.14 0 36.4c0-2.78 1.08-5.4 3.04-7.37l10.41-10.41c1.87-1.87 4.56-2.94 7.37-2.94 2.27 0 4.46.69 6.21 1.96l-2.31 2.3c-2.81-1.76-6.67-1.38-9 .96z'/>
    </g>

    /* eslint-enable */
);
const Interoperability = createIcon(path, {
    width: 47,
    height: 47,
    viewBox: '0 0 47 47'
})

export default Interoperability
